<template>
  <div class="biasfx2">
    <ModalVideoBiliBili
      v-if="showModal"
      :id="showModalId"
      @close="closeModal"
    />
    <ModalBuy v-show="showModalBuy" />
    <Banner :with-bias-banner="true" />
    <div style="position: relative;">
      <BiasMiniGuitarBanner />
    </div>
    <div
      id="section_00"
      class="heroArea bias-fx2-hero mini-guitar-hero row"
    >
      <div
        class="col-xs-12 heroArea-title"
        data-swtp-main-title-align
      >
        <h1 class="main-title">
          BIAS MINI <span>GUITAR</span>
        </h1>
        <h3
          class="subtitle textCenter"
          data-swtp-text=""
          style="color: white; margin: 0; opacity: 1; font-size:30px; font-weight: 600;"
        >
          小身材 大能量
        </h3>
      </div>
      <div class="col-xs-12 heroArea-buy">
        <div
          class="_GUARANTEE_Kicker_Container"
          style="margin: auto; display: table;"
        >
          <span
            id="Kicker Custom 2_1"
            name="Kicker Custom 2"
            type="Kicker Custom 2"
            style="display: inline-block;"
          />
        </div>
      </div>
    </div>
    <section class="intro">
      <p>在更大尺寸的家族成员 BIAS Head 和 BIAS Rack 奠定的基础之上，BIAS MINI Guitar 将同样先进的元件模拟引擎、真实的电子管音箱动态响应和无线连接能力打包进一个更小更轻便的外壳里。只有2.36公斤的重量，但却内置了300瓦的功率放大器，在这个世界上再没有其它的东西能比 BIAS MINI 系列更适合于中小型的演出和录音需要了。</p>
      <div class="text">
        <VideoCard
          :image="'Mini-intro-videoIMG.jpg'"
          :large="true"
          @playVideo="openModal('60242539')"
        />
      </div>
      <BiasMiniGuitarMediaQuote />
    </section>
    <section class="easy-to-use">
      <div>
        <div class="text text-left">
          <h3>使用方便</h3>
          <p>看一眼 BIAS MINI 的前面板就会有种宾至如归的感觉，因为所有旋钮的操作正如你所熟悉的那样。从16个板载预置音色中调用一个，然后就像常规电子管箱头那样调节增益、低频、中频、高频和主音量，接着利用输出按钮在音箱、耳机和线路输出之间进行循环选择，随即就可以开始演奏了。</p>
          <VideoCapsule
            :text="'如何设置 BIAS MINI'"
            @playVideo="openModal('64705486')"
          />
        </div>
      </div>
    </section>
    <section class="power">
      <div>
        <div class="text text-right">
          <h3>小身材 大能量</h3>
          <p>在以前，好音色就意味着昂贵和笨重，但是 BIAS MINI 把这种观念给完全颠覆过来。凭借额定300瓦@ 4 ohms 的内置功率放大器可以随时为中小型演出和录音工作提供足够的动力，而重量仅为2.36公斤，外壳也只有半个机架大小。无论你到哪里去巡演，再也没有任何借口可以不随身携带心爱的音色了。另外还有无暇的效果回路用于加入你心爱的单块，无论什么样的单块都能完美集成。BIAS MINI 让所有的不可能成为可能。</p>
          <VideoCapsule
            :text="'BIAS MINI 音色演示'"
            @playVideo="openModal('64706044')"
          />
        </div>
      </div>
    </section>
    <section class="software">
      <div>
        <div class="text text-left">
          <img src="@/assets/bias-mini-guitar/group-8@2x.png">
          <div class="wrap">
            <VideoCapsule
              :text="'BIAS MINI 音色之旅'"
              @playVideo="openModal('64707773')"
            />
          </div>
        </div>
        <div class="text text-right">
          <h3>强大的软件</h3>
          <p>
            如果你想深入探索音箱定制的世界，BIAS MINI 也附带了我们出色的 BIAS AMP 2 Pro 音箱设计软件（价值 $199美金）。这款软件可以让你重现几乎任何现有音箱的音色和感觉。更厉害的是，它还能让你创造出一台全新的、完全按照你的演奏方式来打造的专属音箱。
            通过内置的蓝牙或 USB 连接，为你打开了一个以前只能靠烙铁打开的元件定制世界：选择不同的前置放大和功率放大电路，更换电子管和变压器，加入削波二极管，尝试不同的整流器 – 所有的一切都是实时发生而且都是那么的真实。这就像你的手中拥有了一间制造精品音箱的工厂。
            如果你经常外出的话，通过我们新的免费增值移动版应用程序 BIAS AMP 2 Mobile，你就可以在 iPad 或 iPhone 上获得与 BIAS AMP 2 一样的强大性能，并且能随时随地即刻体验你喜爱的所有音色。
          </p>
        </div>
      </div>
    </section>
    <div class="clear" />
    <section class="tonecloud">
      <div class="img">
        <img src="@/assets/bias-mini-guitar/connect-tonecloud@2x.png">
        <VideoCapsule
          :text="'100个音箱匹配音色云预设'"
          @playVideo="openModal('64708323')"
        />
      </div>
      <div>
        <h3>连接音色云</h3>
        <p>
          所有的 BIAS 产品都可以连接到 Positive Grid 的音色云上，音色云是我们专为吉他手和音乐人创建的一个云端社区。它不仅仅是一个存储音色的在线容器，它还是一个探索新想法、探索新音色的创新之地。在这个社区里，你不仅可以下载由明星、录音室制作的新音箱，还可以备份并与其他吉他手分享你自己的创造成果，更能与其他志趣相投的音乐人进行交流。
          BIAS AMP 2 软件具备 Amp Match® （音箱匹配）功能，这是通过分析一个源吉他音色来应用必要的纠正处理，从而让一个定制音箱的音色更接近原始的音箱。即使你不准备亲自来做音箱匹配的工作，你仍然可以充分利用这一功能，所要做的只是从音色云上下载其他吉他手已经匹配好的定制音箱。
        </p>
      </div>
    </section>
    <section class="artist">
      <div>
        <h3>特色艺人</h3>
        <div class="text text-left">
          <VideoCard
            :image="'andy-g-jones-head@2x.png'"
            :large="true"
            @playVideo="openModal('64709144')"
          />
        </div>
        <div class="text text-right">
          <VideoCard
            :image="'reece-scruggs-head@2x.png'"
            :large="true"
            @playVideo="openModal('64710987')"
          />
        </div>
      </div>
    </section>
    <div class="clear" />
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import BiasMiniGuitarBanner from '@/components/bias-mini-guitar-banner'
import BiasMiniGuitarMediaQuote from '@/components/bias-mini-guitar-media-quote'
import Banner from '@/components/banner'
import VideoCard from '@/components/video-card'

import ModalVideoBiliBili from '@/components/modal-video-bilibili'
import ModalBuy from '@/components/modal-buy'

import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'

import SoftwareImageLite from '@/assets/fx-software/image-lite@2x.png'
import SoftwareImageStandard from '@/assets/fx-software/image-standard@2x.png'
import SoftwareImagePro from '@/assets/fx-software/image-pro@2x.png'

import ExpansionImageAcoustic from '@/assets/expansion/image-acoustic-pack@2x.png'
import ExpansionImageBass from '@/assets/expansion/image-bass-pack@2x.png'
import ExpansionImageMetal from '@/assets/expansion/image-metal-pack@2x.png'

import VideoCapsule from '@/components/video-capsule'

import { mapState, mapActions, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'Index',
  store,
  components: {
    Banner,
    VideoCard,
    ModalVideoBiliBili,
    FooterWeixin,
    FooterCommon,
    BiasMiniGuitarBanner,
    ModalBuy,
    VideoCapsule,
    BiasMiniGuitarMediaQuote
  },
  data () {
    return {
      showModal: false,
      showModalId: null,
      SoftwareImageLite,
      SoftwareImageStandard,
      SoftwareImagePro,
      ExpansionImageAcoustic,
      ExpansionImageBass,
      ExpansionImageMetal
    }
  },
  computed: {
    ...mapGetters('Auth', {
      isLoginValid: 'isLoginValid'
    }),
    ...mapState('Auth', {
      token: 'token'
    }),
    ...mapState('ModalBuy', {
      showModalBuy: 'show'
    }),
    ...mapState('Software', {
      ownedLicense: 'ownedLicense'
    }),
    ...mapGetters('Software', {
      activeLicenseTier: 'getActiveLicenseTier'
    })
  },
  mounted: function () {
    if (this.isLoginValid) {
      this.getOwnedLicense({ token: this.token, product: 'fx2' })
    }
  },
  methods: {
    ...mapActions('Software', {
      getOwnedLicense: 'getOwnedLicense'
    }),
    openModal (url) {
      this.showModal = true
      this.showModalId = url
    },
    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/pages/bias-fx2.scss";
@import "../styles/pages/bias-mini-guitar.scss";
</style>



// WEBPACK FOOTER //
// src/pages/bias-mini-guitar.vue